export const CLASSTING_URL = process.env.REACT_APP_CLASSTING_URL;

export const HOST_URL = process.env.REACT_APP_HOST_URL;

export const SCHOOL_NEWSLETTER_URL = process.env.REACT_APP_SCHOOL_NEWSLETTER_URL;

export const SLACK_HOOKS_URL = process.env.REACT_APP_SLACK_HOOKS_URL;

export const FIREBASE_AUTH_BASE_URL = process.env.REACT_APP_FIREBASE_AUTH_BASE_URL;
export const LEGACY_API_DOMAIN = process.env.REACT_APP_LEGACY_API_DOMAIN;
export const APIS_DOMAIN = process.env.REACT_APP_APIS_DOMAIN;

export const CHROME_DOWNLOAD_URL = 'https://www.google.com/intl/ko/chrome/';

export const EDGE_DOWNLOAD_URL = 'https://www.microsoft.com/ko-kr/edge';
export const PDF_MANUAL_DOWNLOAD_URL = 'https://www.dropbox.com/s/71t38cj8gtkdspe/%ED%81%B4%EB%9E%98%EC%8A%A4%ED%8C%85_%EC%8A%A4%EC%BF%A8_%EB%A7%A4%EB%89%B4%EC%96%BC.pdf?dl=1';

export const USAGE_GUIDE_URL = 'https://resources.classting.com/schoolletter';
